import request from "./axios";

function index(params) {
  return request({
    method: "get",
    url: `/call_records`,
    params: params
  })
}

function markCompleted(id) {
  return request({
    method: "post",
    url: `/call_records/${id}/mark_completed`
  })
}

const CallRecordsService = {
  index, markCompleted
};

export default CallRecordsService;
